import React from "react";
import { FIRST_INDEX } from "./constants";

/**
 * CutoffInfo component - Displays cutoff date and time
 * @param {string} cutoffDate - Cutoff date string
 * @param {function} formatDateTime - Function to format date and time
 * @param {string} label - Label for cutoff info
 * @param {boolean} isMuted - Whether to mute the text color (for time)
 */
const CutoffInfo = ({ cutoffDate, formatDateTime, label, textSize = "text-[15px]" }) => {
  return (
    <div className="flex flex-col items-center gap-[8px]">
      <div className="font-semibold text-2xl text-center">
        {label}
      </div>
      <div className="flex gap-1">
        <div className={textSize}>
          {cutoffDate?.split("T")[FIRST_INDEX]}
        </div>
        <div className={`${textSize} dark:text-white text-gray-600`}>
          {formatDateTime(cutoffDate).formattedTime}
        </div>
      </div>
    </div>
  );
};

export default CutoffInfo;
